import { RackMaterial } from '@/shared/types/configurator';
import { BeamPrices, ShelfPrices } from '@/shared/types/price';

export interface GoogleTableResponse {
	table: {
		cols: ColumnOptions[];
		rows: Row[];
	};
}

export interface ColumnOptions {
	label: string;
}

export interface Row {
	c: RowValue[];
}

export interface RowValue {
	v: string | number;
}

export enum TableKey {
	HEIGHT = 'height',
	WIDTH = 'width',
	DEPTH = 'depth',
	PRICE = 'price',
	RACK = 'rack',
	DECK = 'deck',
}

export interface ConfiguratorResultData {
	heights: Record<RackMaterial, number[]>;
	widths: number[];
	depths: number[];
	prices: {
		beams: BeamPrices;
		shelves: ShelfPrices;
		connector: number;
	};
}

export interface CacheData {
	data: ConfiguratorResultData;
	version: string;
}

export function isValidValueType(value: unknown): value is string | number {
	return typeof value === 'string' || typeof value === 'number';
}
